import React from "react";
import AppleSignInButton from "../auth/AppleSignInButton";

/**
 * Social login extras — Apple Sign-In only.
 * WhatsApp and SMS were intentionally removed per product decision: the
 * supported login methods on Thqah are Email/Password, Google, and Apple.
 */
export default function SocialLoginExtras() {
  return (
    <div className="space-y-2">
      <AppleSignInButton />
    </div>
  );
}
